import { updateOfferlessConfig } from '../graphql/mutations';
import { getOfferlessConfig } from '../graphql/queries';
import { makeApiAction } from './actions';

export const fetchOfferlessConfigAction = (restId) => (dispatch) => {
  const action = 'FETCH_OFFERLESS_CONFIG';
  const data = {
    restId,
  };

  dispatch(makeApiAction(action, getOfferlessConfig, data, {}, 'getOfferlessConfig', false));
};

export const enableOfferlessConfigAction = () => (dispatch) => {
  const action = 'UPDATE_OFFERLESS_CONFIG';
  const data = {
    offerlessEnabled: true,
  };

  dispatch(makeApiAction(action, updateOfferlessConfig, data, data, 'offerlessConfig', true));
};
